var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import React from 'react';
import TaxesTable from './container/TaxesTable';
import TaxForm from './container/TaxForm';
import { TaxCategory } from './Model';
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Index.prototype.render = function () {
        var taxCategories = Object.keys(TaxCategory).map(function (key, object) { return object[key]; });
        return (React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/taxes", component: TaxesTable }),
            React.createElement(Route, { exact: true, path: "/taxes/create", component: TaxForm }),
            React.createElement(Route, { exact: true, path: "/taxes/:id", component: function (props) { return React.createElement(TaxForm, __assign({}, props)); } })));
    };
    return Index;
}(Component));
export default Index;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/index.tsx
// module id = 1261
// module chunks = 0